import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import References from "../../components/References";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_1_2_5 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main>
          <section className="mb-5">
            <h1 className="blue text-uppercase b mt-5">
              1.2.5 Amyvid Adverse Reactions
            </h1>
            <p className="mt-1 mb-0">Estimated time to complete: 1 minute</p>
          </section>
          <section className="mb-5 row">
            <div className="col-sm-12 col-md-6">
              <ul>
                <li>
                  In clinical studies, 555 patients were exposed to Amyvid
                </li>
                <li>
                  Because clinical trials are conducted under widely varying
                  conditions, adverse reaction rates observed in the clinical
                  trials of a drug cannot be directly compared to rates in the
                  clinical trials of another drug and may not reflect the rates
                  observed in clinical practice
                </li>
                <li>
                  Amyvid caused no serious adverse reactions and the reported
                  adverse reactions were predominantly mild to moderate in
                  severity
                </li>
                <li>
                  The adverse reactions reported in more than one subject within
                  the studies are shown in the table here
                </li>
                <li>
                  Other adverse reactions occurred at lower frequencies and
                  included infusion site rash, dysgeusia, pruritus, urticaria,
                  and flushing
                </li>
              </ul>
            </div>
            <div className="col-sm-12 col-md-6">
              <section>
                <h2 className="h5 b">
                  Adverse Reactions in Clinical Trials (N=555)
                </h2>
                <table className="text-center">
                  <caption>
                    <p className="m-0">
                      <sup>a</sup> Includes the terms blood pressure increased
                      and hypertension.
                    </p>
                    <p className="m-0">
                      <sup>b</sup> Includes the terms injection site hemorrhage,
                      injection site irritation, and injection site pain.
                    </p>
                    <p className="m-0">
                      <sup>c</sup> Includes the terms feeling cold and chills.
                    </p>
                  </caption>
                  <tr>
                    <th scope="col">Adverse Reactions</th>
                    <th scope="col">Percentage of Patients</th>
                  </tr>
                  <tr>
                    <td>Headache</td>
                    <td>1.8%</td>
                  </tr>
                  <tr>
                    <td>Musculoskeletal pain</td>
                    <td>0.7%</td>
                  </tr>
                  <tr>
                    <td>
                      Blood pressure increased<sup>a</sup>
                    </td>
                    <td>0.7%</td>
                  </tr>
                  <tr>
                    <td>Nausea</td>
                    <td>0.7%</td>
                  </tr>
                  <tr>
                    <td>Fatigue</td>
                    <td>0.5%</td>
                  </tr>
                  <tr>
                    <td>
                      Injection site reaction<sup>b</sup>
                    </td>
                    <td>0.5%</td>
                  </tr>
                  <tr>
                    <td>Anxiety</td>
                    <td>0.4%</td>
                  </tr>
                  <tr>
                    <td>Back pain</td>
                    <td>0.4%</td>
                  </tr>
                  <tr>
                    <td>Claustrophobia</td>
                    <td>0.4%</td>
                  </tr>
                  <tr>
                    <td>Dizziness</td>
                    <td>0.4%</td>
                  </tr>
                  <tr>
                    <td>
                      Feeling cold<sup>c</sup>
                    </td>
                    <td>0.4%</td>
                  </tr>
                  <tr>
                    <td>Insomnia</td>
                    <td>0.4%</td>
                  </tr>
                  <tr>
                    <td>Neck pain</td>
                    <td>0.4%</td>
                  </tr>
                </table>
              </section>
            </div>
          </section>
          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-1/module-1-2-4", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              onClick={function navClick() {
                window.open("/module-1/module-1-3-1", "_self");
              }}
            >
              Next Lesson
            </LdsButton>
          </section>

          <References>
            <p className="no-indent fz-sm">
              Amyvid (florbetapir F 18 injection) Prescribing Information. Lilly
              USA, LLC.
            </p>
          </References>
        </main>
      </div>
    </div>
  );
};

export default Module_1_2_5;
